var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"text-dialog flex flex-column"},[_c('div',{staticClass:"text-content flex-1",domProps:{"innerHTML":_vm._s(_vm.content.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }